import { render } from "./EmailCommunication.vue?vue&type=template&id=930bd806&scoped=true"
import script from "./EmailCommunication.vue?vue&type=script&lang=js"
export * from "./EmailCommunication.vue?vue&type=script&lang=js"

import "./EmailCommunication.vue?vue&type=style&index=0&id=930bd806&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930bd806"]])

export default __exports__